import { HTTPClient } from "../common/HTTPClient";

export interface TMSRegisterRequestParams {
  id?: number;
  name: string;
  email: string;
  tel: string;
}

export class TMSClient {
  constructor(private httpClient: HTTPClient) {}

  public async createShop(params: TMSRegisterRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/shop-delivery/tms-register",
      method: "POST",
      data: params
    });

    return data;
  }
}
